<div
  class="tooltip animate__animated animate__fadeIn animate__delay-1s"
  role="tooltip"
  #tooltip
>
  <span>{{ text }}</span>
  <div class="arrow" #arrow></div>
</div>
